import { type ReactNode } from 'react';
import { cx } from './utils.js';

export function Table(props: { head: string[]; children: ReactNode; foot?: ReactNode }) {
  return (
    <div className="overflow-x-auto">
      <table className="w-full text-left text-sm">
        <thead>
          <tr className="border-b border-[color:var(--admin-border,#d8dee6)] bg-[color:var(--admin-paper,#f4f6f8)] dark:border-slate-800 dark:bg-slate-950/60">
            {props.head.map((cell) => (
              <th
                key={cell}
                className="admin-mono px-4 py-2.5 text-[10px] font-medium tracking-[0.14em] text-slate-500 uppercase first:pl-5 dark:text-slate-400"
              >
                {cell}
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="divide-y divide-[color:var(--admin-border-soft,#e8edf2)] dark:divide-slate-800">
          {props.children}
        </tbody>
        {props.foot ? (
          <tfoot className="border-t border-[color:var(--admin-border)] bg-[color:var(--admin-paper,#f4f6f8)] font-medium dark:border-slate-700 dark:bg-slate-800/60">
            {props.foot}
          </tfoot>
        ) : null}
      </table>
    </div>
  );
}

export function Td(props: {
  children?: ReactNode;
  className?: string | undefined;
  muted?: boolean;
  colSpan?: number;
}) {
  return (
    <td
      colSpan={props.colSpan}
      className={cx(
        'px-4 py-3 align-middle first:pl-5',
        props.muted
          ? 'text-slate-500 dark:text-slate-400'
          : 'text-slate-800 dark:text-slate-200',
        props.className,
      )}
    >
      {props.children}
    </td>
  );
}
